export default {
  getMessage(field, args) {
    return field
  },
  validate(value, args) {
    return args[0] > 0
  }
}
